<mat-card-header>
    <div class="text-center">
      <h3>My Sporsorships</h3>
  </div>
    <!-- <mat-card-subtitle>Example of a home screen</mat-card-subtitle> -->
    <br>
    
  </mat-card-header>
  <mat-card-content>
    <a class="btn btn-success active btn-add mb-2"><b>+</b> New Sporsorship</a>
    <table
    class="table">
    <thead>
        <tr>
        <th class="text-center">
            <small>Logo</small>
        </th>
        <th><small>Name</small></th>
        <th class="text-center"><small>Property Name</small></th>
        <th class="text-center"><small>Sponsor Name</small></th>
        </tr>
    </thead>
    <tbody>
        <tr>
            <td class="text-center">
                <div></div>
            </td>
            <td class="text-center">
                <div></div>
            </td>
  
            <td class="text-center">
                <div></div>
            </td>
  
            <td class="text-center">
                <div></div>
            </td>
        </tr>
    </tbody>
  </table>
  </mat-card-content>
  